export const DEFAULT_CDN_IMAGE = "/images/default-image.png"

export const getCDNImage = (relativePath: string) =>
	`${__ENV__.IMAGE_CDN_URL}${relativePath.startsWith("/") ? "" : "/"}${relativePath}`
